(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-retractation"]) return;
  try {
    
(() => {
  const contextLifetime = 30 * 60 * 1000;
  const fields = ['order', 'orderDate', 'name', 'email', 'items'];
  const limits = {order: 80, orderDate: 10, name: 160, email: 254, items: 300};
  const clean = (value, limit) => String(value || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, limit);
  const normalize = values => Object.fromEntries(fields.map(field => [field, clean(values[field], limits[field])]));
  const validValues = values => Boolean(values.order && values.name && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email) && (!values.orderDate || /^\d{4}-\d{2}-\d{2}$/.test(values.orderDate)));
  const validPending = (pending, now) => Boolean(pending && pending.version === 1 && /^[a-z0-9-]{16,100}$/i.test(pending.nonce || '') && Number.isFinite(pending.createdAt) && pending.createdAt <= now && now - pending.createdAt <= contextLifetime && pending.values && validValues(normalize(pending.values)));
  const valueFor = (values, field, copy) => values[field] || (field === 'items' ? copy.all_items : copy.not_provided);
  const declaration = (values, copy, sentAt) => [copy.declaration, '', ...fields.map(field => `${copy[field]} : ${valueFor(values, field, copy)}`), ...(sentAt ? ['', `${copy.sent_time} : ${new Date(sentAt).toISOString()}`] : [])].join('\n');
  const receipt = (state, copy, now) => {
    if (!state.success || state.errors || !validPending(state.pending, now)) return null;
    const frozen = state.pending.confirmation;
    if (frozen) {
      if (typeof frozen.content !== 'string' || !frozen.content || frozen.content.length > 12000 || frozen.sentAt !== new Date(state.pending.createdAt).toISOString() || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}[+-]\d{4}$/.test(frozen.serverTime || '') || typeof frozen.serverTimeLabel !== 'string' || !frozen.serverTimeLabel || frozen.serverTimeLabel.length > 100) return null;
      return frozen.content;
    }
    if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}[+-]\d{4}$/.test(state.serverTime || '') || !state.serverTimeLabel) return null;
    return [copy.receipt_title, '', declaration(normalize(state.pending.values), copy, state.pending.createdAt), '', `${copy.server_time} : ${state.serverTimeLabel}`, '', copy.receipt_note].join('\n');
  };
  const init = root => {
    if (root.dataset.withdrawalInitialized) return;
    root.dataset.withdrawalInitialized = 'true';
    let copy;
    try { copy = JSON.parse(root.querySelector('[data-withdrawal-copy]').textContent); } catch { return; }
    const storageKey = `maison-sourdine:withdrawal:${location.pathname}:${root.dataset.sectionId}`;
    const read = () => {
      try { return JSON.parse(sessionStorage.getItem(storageKey)); } catch { return null; }
    };
    const clear = () => { try { sessionStorage.removeItem(storageKey); } catch {} };
    const success = root.querySelector('[data-withdrawal-success]');
    const errors = root.querySelector('[data-withdrawal-errors]');
    if (success) {
      const context = read();
      const content = receipt({success: true, errors: Boolean(errors), pending: context, serverTime: success.dataset.serverTime, serverTimeLabel: success.dataset.serverTimeLabel}, copy, Date.now());
      if (content) {
        const confirmation = context.confirmation || {content, sentAt: new Date(context.createdAt).toISOString(), serverTime: success.dataset.serverTime, serverTimeLabel: success.dataset.serverTimeLabel};
        try { sessionStorage.setItem(storageKey, JSON.stringify({...context, confirmation})); } catch { clear(); }
        const area = success.querySelector('[data-withdrawal-receipt]');
        success.querySelector('[data-withdrawal-receipt-copy]').textContent = content;
        success.querySelector('[data-withdrawal-receipt-unavailable]').hidden = true;
        area.hidden = false;
        area.querySelector('[data-withdrawal-download]').addEventListener('click', () => {
          const url = URL.createObjectURL(new Blob(['\ufeff', content], {type: 'text/plain;charset=utf-8'}));
          const link = document.createElement('a');
          link.href = url;
          link.download = `retractation-maison-sourdine-${confirmation.serverTime.slice(0, 10)}.txt`;
          document.body.append(link);
          link.click();
          link.remove();
          setTimeout(() => URL.revokeObjectURL(url), 1000);
        });
        setTimeout(() => { clear(); area.hidden = true; success.querySelector('[data-withdrawal-receipt-unavailable]').hidden = false; }, Math.max(0, contextLifetime - (Date.now() - context.createdAt)) + 1);
      } else {
        clear();
      }
      success.querySelector('[data-withdrawal-success-heading]').focus();
      return;
    }
    const enhanced = root.querySelector('[data-withdrawal-enhanced]');
    if (!enhanced) return;
    const form = enhanced.closest('form');
    const edit = enhanced.querySelector('[data-withdrawal-edit]');
    const confirm = enhanced.querySelector('[data-withdrawal-confirm]');
    const controls = Object.fromEntries(fields.map(field => [field, enhanced.querySelector(`[data-withdrawal-field="${field}"]`)]));
    const body = enhanced.querySelector('[data-withdrawal-body]');
    const summary = enhanced.querySelector('[data-withdrawal-summary]');
    let approved = null;
    let sentAt = null;
    const values = () => normalize(Object.fromEntries(fields.map(field => [field, controls[field].value])));
    const pending = read();
    if (errors && validPending(pending, Date.now())) {
      const restored = normalize(pending.values);
      fields.forEach(field => { controls[field].value = restored[field]; });
    }
    clear();
    enhanced.hidden = false;
    const showEdit = () => {
      approved = null;
      sentAt = null;
      edit.hidden = false;
      confirm.hidden = true;
    };
    const review = () => {
      if (!form.reportValidity()) return;
      const current = values();
      if (!validValues(current)) return;
      approved = current;
      sentAt = null;
      body.value = declaration(current, copy);
      summary.replaceChildren();
      fields.forEach(field => {
        const row = document.createElement('div');
        const label = document.createElement('dt');
        const value = document.createElement('dd');
        label.textContent = copy[field];
        value.textContent = valueFor(current, field, copy);
        row.append(label, value);
        summary.append(row);
      });
      edit.hidden = true;
      confirm.hidden = false;
      enhanced.querySelector('[data-withdrawal-review-heading]').focus();
    };
    enhanced.querySelector('[data-withdrawal-review]').addEventListener('click', review);
    enhanced.querySelector('[data-withdrawal-back]').addEventListener('click', () => {
      showEdit();
      controls.order.focus();
    });
    form.addEventListener('submit', event => {
      const current = values();
      if (!approved || confirm.hidden || JSON.stringify(current) !== JSON.stringify(approved)) {
        event.preventDefault();
        review();
        return;
      }
      if (!form.reportValidity()) {
        event.preventDefault();
        return;
      }
      const nonce = typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : Array.from(crypto.getRandomValues(new Uint8Array(20)), value => value.toString(16).padStart(2, '0')).join('');
      sentAt = sentAt || Date.now();
      body.value = declaration(current, copy, sentAt);
      try { sessionStorage.setItem(storageKey, JSON.stringify({version: 1, nonce, createdAt: sentAt, values: current})); } catch {}
      enhanced.querySelector('[data-withdrawal-submit]').textContent = copy.sending;
    });
    addEventListener('pageshow', event => { if (event.persisted) { clear(); showEdit(); enhanced.querySelector('[data-withdrawal-submit]').textContent = copy.confirm; } });
  };
  document.querySelectorAll('[data-withdrawal]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-withdrawal]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
